import React from 'react'
import cx from 'classnames'

import styles from './Item.module.scss'

export const Item = React.forwardRef(
  ({ children, className = undefined, ...restProps }, ref) => (
    <li
      className={cx(styles.item, { [className]: Boolean(className) })}
      {...restProps}
      {...{ ref }}
    >
      {children}
    </li>
  ),
)
